var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle64D = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 65 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M28.807 3.274A2.5 2.5 0 0 0 26.317 1h-5.434a2.5 2.5 0 0 0-2.49 2.274l-.545 6A2.5 2.5 0 0 0 20.338 12h6.524a2.5 2.5 0 0 0 2.49-2.726l-.545-6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M26.861 2c.687 0 1.314.388 1.622 1.002l.222.445a1 1 0 0 0 1.79-.894l-.224-.446A3.812 3.812 0 0 0 26.861 0h-6.523a3.812 3.812 0 0 0-3.41 2.107l-.223.446a1 1 0 1 0 1.79.894l.222-.445A1.812 1.812 0 0 1 20.337 2h6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M48.807 3.274A2.5 2.5 0 0 0 46.317 1h-5.434a2.5 2.5 0 0 0-2.49 2.274l-.545 6A2.5 2.5 0 0 0 40.338 12h6.524a2.5 2.5 0 0 0 2.49-2.726l-.545-6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M46.861 2c.687 0 1.315.388 1.622 1.002l.222.445a1 1 0 0 0 1.79-.894l-.224-.446A3.812 3.812 0 0 0 46.861 0h-6.523a3.812 3.812 0 0 0-3.41 2.107l-.223.446a1 1 0 1 0 1.79.894l.222-.445A1.812 1.812 0 0 1 40.337 2h6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M14.602 31.5a2.5 2.5 0 0 0 2.5 2.5h31a2.5 2.5 0 0 0 2.5-2.5v-15a2.5 2.5 0 0 0-2.5-2.5h-31a2.5 2.5 0 0 0-2.5 2.5v15Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M1.6 44.5V10l7.251-.725a2.5 2.5 0 0 1 2.75 2.487L11.6 34.5a2.5 2.5 0 0 0 2.5 2.5h32.922a2.5 2.5 0 0 1 2.478 2.835l-.97 7.164L4.1 47a2.5 2.5 0 0 1-2.5-2.5Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M1.6 8a1 1 0 0 0-1 1v35.5A3.5 3.5 0 0 0 4.1 48h45.4a1 1 0 1 0 0-2H4.1a1.5 1.5 0 0 1-1.5-1.5V9a1 1 0 0 0-1-1Z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M63.9 44.5V10l-7.251-.725a2.5 2.5 0 0 0-2.75 2.487L53.9 34.5a2.5 2.5 0 0 1-2.5 2.5H18.478A2.5 2.5 0 0 0 16 39.834l.97 7.164L61.4 47a2.5 2.5 0 0 0 2.5-2.5Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M63.9 8a1 1 0 0 1 1 1v35.5a3.5 3.5 0 0 1-3.5 3.5H16a1 1 0 1 1 0-2h45.4a1.5 1.5 0 0 0 1.5-1.5V9a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})));
SvgRectangle64D.viewBox = '0 0 65 48';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle64D);
export default ForwardRef;